<template>
        <!-- 新增退货单 -->
        <Modal draggable v-model="show"
            title="退货单详情"
            class-name="vertical-center-modal"
            @on-visible-change="onShowChange"
            width="800">
            <Spin v-if="innerSpin"
                size="large"
                fix></Spin>
            <Form label-position="top">
                <Row :gutter="16">
                    <Col span="8">
                    <FormItem label="关联发货单号">
                        <Input readonly v-model="preSaleDeliveryRecord.billCode"></Input>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="会员号">
                        <Input readonly
                            v-model="preSaleDeliveryRecord.userName"></Input>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="会员名称">
                        <Input readonly
                            v-model="preSaleDeliveryRecord.userExternalCustomerName"></Input>
                    </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="8">
                    <FormItem label="发货日期">
                        <Input readonly v-model="sendDeliveryDate"></Input>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="退货数量">
                        <Input readonly
                            v-model="preSaleDeliveryRecord.returnQuantity"></Input>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="退货金额">
                        <Input readonly
                            v-model="preSaleDeliveryRecord.returnAmount"></Input>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <Row :gutter="16">
                <Col span="24">
                <Table size="small"
                    :columns="returnOrderTable.columns"
                    :data="preSaleDeliveryDetails"
                    :loading="returnOrderTable.loading"
                    highlight-row
                    stripe
                    border />
                </Col>
            </Row>
            <div slot="footer">
                <Button type="primary"
                    @click="onReturnOrderDetailSave">确认</Button>
                <Button type="error"
                    @click="show=false">取消</Button>
            </div>
    </Modal>
</template>

<script>
import { formatDateString, formatDateTimeString } from '@/libs/logic';
import { DELIVERYWAYS_SELFMENTION, DELIVERYWAYS_TRANSFERSTATION, DELIVERYWAYS_LOGISTICS, deliveryWaysFormat } from '@/libs/baseModelFormat';
import { getPreSaleDeliveryRecord } from '@/api/modules/preSale-management/preSale-delivery';
import { saveRefundGoods } from '@/api/modules/finance-management/refund-goods';
import { FILE_SERVER } from '@/api/modules/files';

export default {
    name: 'RefundGoods',
    data() {
        return {
            showPoptip:true,
            sendDeliveryDate:'',
            show: false,
            innerSpin: false,
            orderUuid: '',
            preSaleDeliveryRecordUuid: '',
            preSaleDeliveryRecord: {},
            preSaleDeliveryDetails: [],
            returnOrderTable: {
                columns: [
                    { title: "编号", key: "productCode", align: "center" },
                    { title: "品名", key: "productName", align: "center" },
            		{ title: "销售单价", key: "preSalePlanPrice", align: "center" },
                    { title: "销售数量", key: "orderQuantity", align: "center" },
            		{ title: "退货数量", key: "returnQuantity", align: "center",
            			render: (h, params) => {
            				   return h('input', {
            					 domProps: {
            						 value: params.row.returnQuantity
            					 },
            					 style:{
            						 textAlign: "center",
            						 width:"60px"
            					 },
            					 on: {
            						 change: (event) => {
            							 this.updateRow(params.row, event.target.value);
            							}
            						}
            					});
            			}
            		},
            		{ title: "有效数量", key: "effectiveQuantity", align: "center" },
            		{ title: "销售金额", key: "totalMoney", align: "center" },
                    { title: "退货金额", key: "returnAmount", align: "center" },
            		{ title: "有效金额", key: "effectiveAmount", align: "center" }
                ],
                loading: false
            }
        };
    },
    mounted() {

    },
    methods: {
        updateRow(row, refundNum){
            let newDetails = [];
            this.preSaleDeliveryDetails.forEach(item =>{
                if(row.preSaleDeliveryDetailUuid == item.preSaleDeliveryDetailUuid){
                    if(parseInt(refundNum) > parseInt(item.orderQuantity)){
                        refundNum = 0;
                    }
                    item.returnQuantity = parseInt(refundNum);
                    item.effectiveQuantity = parseInt(item.orderQuantity) - parseInt(refundNum);
                    item.returnAmount = (item.preSalePlanPrice * parseInt(refundNum)).toFixed(3);
                    // item.effectiveAmount = item.totalMoney - item.returnAmount;
                    item.effectiveAmount = (((item.totalMoney * 1000) - (item.returnAmount * 1000))/1000).toFixed(2);
                }
                newDetails.push(item);
            });
            this.preSaleDeliveryDetails = newDetails;
            this.calcRefundInfo();
        },
        calcRefundInfo(){
            let totalNum = 0;
            let totalAmount = 0.0;
            this.preSaleDeliveryDetails.forEach(item =>{
                if(item.returnQuantity > 0){
                    totalNum += item.returnQuantity;
                    totalAmount += item.preSalePlanPrice * item.returnQuantity;
                }
            });
            this.preSaleDeliveryRecord.returnQuantity = totalNum;
            this.preSaleDeliveryRecord.returnAmount = totalAmount.toFixed(2);
        },
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(orderUuid) {
            this.orderUuid = orderUuid;
            this.show = true;
        },
        init() {
            if (this.orderUuid) {
                this.preSaleDeliveryRecordUuid = this.orderUuid;
                this.innerSpin = true;
                this.preSaleDeliveryDetails = [];
                getPreSaleDeliveryRecord({ preSaleDeliveryRecordUuid:this.preSaleDeliveryRecordUuid, isSign:2 }).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        if(res.data.recordList.length>0){
                            this.sendDeliveryDate=formatDateString(res.data.recordList[0].preSaleDeliveryRecordDeliveryDate);
                            this.preSaleDeliveryRecord = res.data.recordList[0];
                            let orderItemList = res.data.recordList[0].orderItmeList;
                            orderItemList.forEach(item => {
                                if(item.preSaleDeliveryRecordUuid){
                                    item.returnQuantity = 0;
                                    item.effectiveQuantity = item.orderQuantity;
                                    item.returnAmount = 0.0;
                                    this.preSaleDeliveryDetails.push(item);
                                }
                            });

                            this.preSaleDeliveryRecord.returnQuantity = 0;
                            this.preSaleDeliveryRecord.returnAmount = 0.0;
                        }
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            };
        },
        formatDateString,
        formatDateTimeString,

        onReturnOrderDetailSave() {

            let refundItems = [];

            this.preSaleDeliveryDetails.forEach(item => {
                if(item.returnAmount > 0){
                    refundItems.push({
                        productId : this.orderUuid,
                        productCode: item.productCode,
                        productName: item.productName,
                        salePrice: item.preSalePlanPrice,
                        saleNum: item.orderQuantity,
                        refundNum: item.returnQuantity,
                        actualNum: item.effectiveQuantity,
                        saleAmount: item.totalMoney,
                        refundAmount: item.returnAmount,
                        actualAmount: item.effectiveAmount
                    });
                }
            });

            let requestParam = {
                refundGoodsDetails : refundItems,
                relateDeliveryRecordId : this.orderUuid,
                deliveryRecordOwnerUserName : this.preSaleDeliveryRecord.userName
            };

            this.innerSpin = true;
            saveRefundGoods(requestParam).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Message.success('申请退货成功！');
                    this.show = false;
                    this.$emit('close');
                }
            });
        }
    }
};
</script>

<style scoped>
	.ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper{height:32px;line-height:32px;font-size:12px;padding:0px 10px;}
	.ivu-table-cell input{text-align: center;}
</style>
